import React, { useState } from "react";
import "./App.css";
import Topbar from "./components/Topbar";
import LandingSection from "./components/LandingSection";
import MessageSection from "./components/MessageSection";
import YouTubeEmbed from "./components/YoutubeEmbed";
import ChooseUsSection from "./components/ChooseUsSection";
import YouGet from "./components/YouGet";
import Value from "./components/Value";
import Deal from "./components/Deal";
import JoinUs from "./components/JoinUs";
import FoundersCircle from "./components/FoundersCircle";
import Research from "./components/Research";
import Footer from "./components/Footer";

function App() {
  const [isVisible, setIsVisible] = useState(false);

  const checkScroll = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Detect scroll position to show/hide the back-to-top button
  React.useEffect(() => {
    window.addEventListener("scroll", checkScroll);
    return () => window.removeEventListener("scroll", checkScroll);
  }, []);

  return (
    <>
      <div className="bg-gray-100 min-h-screen">
        <Topbar />
        <LandingSection />
        <MessageSection />
        <div className="w-1/2 mx-auto border-t-2 border-gray-400 my-4"></div>
        <YouTubeEmbed />
        <ChooseUsSection />
        <YouGet />
        <div className="flex items-center justify-center">
          <span className="text-3xl font-bold text-gray-400">•</span>
          <span className="text-3xl font-bold mx-4 text-gray-400">•</span>
          <span className="text-3xl font-bold text-gray-400">•</span>
        </div>
        <Value />
        <Deal />
        <JoinUs />
        <FoundersCircle />
        <Research />
        <Footer />
      </div>

      {/* Back to Top Button */}
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 bg-blue-500 text-white p-4 rounded-full shadow-lg hover:bg-blue-600 transition-colors"
        >
          ↑
        </button>
      )}
    </>
  );
}

export default App;
